<template>
  <div class="createliveroom wrapper">
    <div class="title-layer">直播信息</div>
    <div class="content-layer">

      <div class="field-layer border-bottom">
        <label>直播名称</label>
        <input
          :disabled="liveData.status==1"
          type="search"
          placeholder="请输入直播名称"
          v-model="liveData.roomName"
          class="info-input"
          @blur="blurInput"
        />
      </div>

      <div class="field-layer border-bottom">
        <label>直播人</label>
        <input
          :disabled="liveData.status==0&&rid!=''"
          type="search"
          placeholder="请输入直播人"
          v-model="liveData.anchorName"
          class="info-input"
          @blur="blurInput"
        />
      </div>

      <div class="field-layer border-bottom">
        <label>直播楼盘</label>
        <input
          :disabled="liveData.status==1"
          type="search"
          placeholder="请输入直播楼盘"
          v-model="liveData.anchorCompany"
          class="info-input"
          @blur="blurInput"
        />
      </div>

      <div class="label-layer">分享主图</div>
      <div class="upimg-layer">
        <div class="upimg">
          <upimg :multiple="multiple" id="id" :url="url" @changeUrl="changeUrl" :len="len" v-show="liveData.status!=1"></upimg>
          <img :src="liveData.bannerImgUrl" alt v-if="liveData.bannerImgUrl" />
        </div>
      </div>
      <div class="note-layer border-bottom">(点击图片可修改图片，此图片将做为分享主图)</div>

      <div class="label-layer">内容介绍</div>
      <textarea
        :disabled="liveData.status==1"
        rows=3
        maxlength=100
        placeholder="请输入内容介绍"
        v-model="liveData.briefIntroduction"
        class="info-area"
        @blur="blurInput"
        @input="textInput"
      />
      <div class="number-layer">{{shownumber > 100 ? 100 : shownumber}} / {{number}}</div>
    </div>

    <div class="title-layer" v-show="showCoupon">直播活动</div>
    <div class="switch-layer" v-show="showCoupon">
      <div class="left">
        <div class="t1">是否开启抢券活动</div>
        <div class="t2">在直播中，主持人可发起抢券活动</div>
      </div>
      <mt-switch v-model="liveData.hasCoupon"></mt-switch>
    </div>

    <div class="title-layer">直播时间</div>
    <div class="content-layer">
      <!-- <div class="field-layer border-bottom">
        <label>预计开始日期</label>
        <span v-if="liveData.status!=1" @click="selectData">{{showPlanDateToStart}}</span>
        <span v-if="liveData.status==1">{{showPlanDateToStart}}</span>
        <div class="selTime">
          <mt-datetime-picker
            lockScroll="true" 
            ref="picker"
            v-model="liveData.planDateToStart"
            type="date"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日"
            :start-date="startDate"
            @confirm="handleConfirm"
            @visible-change="handleValueChange"
          ></mt-datetime-picker>
        </div>
      </div>  -->
      <!-- <div class="field-layer border-bottom">
        <label>预计开始时间</label>
        <span v-if="liveData.status==1">{{liveData.planTimeToStart}}</span>
        <span v-if="liveData.status!=1" @click="selectData2">{{liveData.planTimeToStart}}</span>
        <div class="selTime">
          <mt-datetime-picker
            ref="picker2"
            v-model="liveData.planTimeToStart"
            type="time"
            :start-hour ='startHour'
            @confirm="handleConfirm2"
            @visible-change="handleValueChange"
          ></mt-datetime-picker>
        </div>
      </div>  -->
      <div class="field-layer border-bottom">
        <label>预计开始日期</label>
        <span v-if="liveData.status!=1" @click="showPopup">{{showPlanDateToStart}}</span>
        <span v-if="liveData.status==1">{{showPlanDateToStart}}</span>
        <div class="selTime">
          <van-popup v-model="show" position="bottom">
            <van-datetime-picker
              v-model="liveData.planDateToStart"
              type="date"
              title="选择日期"
              :loading="isLoadingShow"
              :min-date="startDate"
              @cancel="show = false"
              @confirm="confirmPicker"
            />
          </van-popup>
        </div>
      </div> 
      <div class="field-layer border-bottom">
        <label>预计开始时间</label>
        <span v-if="liveData.status==1">{{liveData.planTimeToStart}}</span>
        <span v-if="liveData.status!=1" @click="showPopup2">{{liveData.planTimeToStart}}</span>
        <div class="selTime">
          <van-popup v-model="show2" position="bottom">
            <van-datetime-picker
              v-model="liveData.planTimeToStart"
              type="time"
              title="选择时间"
              :loading="isLoadingShow2"
              :min-hour="startHour"
              :min-minute = "startMinute"
              @cancel="show2 = false"
              @confirm="confirmPicker2"
              @change = "change"
            />
          </van-popup>
        </div>
      </div> 
    </div>

    <div class="btn-layer" @click="createLiveRoom">保存并创建直播</div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import * as config from "./config";
import { MessageBox, Switch, Indicator } from "mint-ui"; //上拉刷新
import { mapState, mapMutations } from "vuex";
import upimg from "@/components/upimglive";
import Vue from "vue";
import Cookies from "js-cookie";
import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import 'vant/lib/index.css';
Vue.use(Popup);
Vue.use(DatetimePicker);

Vue.component(Switch.name, Switch);
export default {
  components: {
    upimg
  },
  props: {
    
  },
  data() {
    return {
      handler: function(e){ //解决页面层级相互影响滑动的问题
        e.preventDefault()
      },
      pid: (this.$route.query.pid ? parseInt(this.$route.query.pid) : ''),
      rid: (this.$route.query.rid ? this.$route.query.rid : ''),
      curProject: null,
      userInfo: null,
      //直播间数据
      liveData: {
        roomName: '',
        anchorName: '',
        anchorCompany: '',
        briefIntroduction: '',
        planDateToStart: '',
        planTimeToStart: '',
        bannerImgUrl: '',
        hasCoupon: false,
        status: 0,
      },
      showPlanDateToStart: '',
      isPlanDateToStart: false,
      //上传图片
      multiple: false,
      id: "upimg",
      url: [],
      len: 1,

      showCoupon: false,
      number: 100,
      shownumber: 0,
      startDate: new Date(),
      startHour: 0,
      startTime: util.formatDate(new Date().getTime(), 1),

      show: false,
      isLoadingShow: true,
      startMinute: 0,
      show2: false,
      isLoadingShow2: true,
    };
  },
  filters: {
      formatDate(time){
        var date = new Date(time);
       return  util.formatDate(date)
      }
  },
  watch: {
    liveData: {
      handler(val){
        if(val.planDateToStart==this.showPlanDateToStart){
          this.isPlanDateToStart = true
        }
      },
    },
    url: {
      handler(val) {
        this.liveData.bannerImgUrl = val[0];
      }
    }
  },
  computed: {
    ...mapState(["pageInfo", "isInMiniProgram", "shareSpreadInfo", "receiveSpreadInfo",])
  },
  methods: {
    showPopup () {
      this.show = true
      this.isLoadingShow = true
      setTimeout(() => {
        this.isLoadingShow = false
      }, 500)
    },
    confirmPicker (val) {
      let year = val.getFullYear()
      let month = val.getMonth() + 1
      let day = val.getDate()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      this.liveData.planDateToStart = `${year}-${month}-${day}`
      this.$nextTick(()=>{
         this.liveData.planDateToStart = `${year}-${month}-${day}`
      })
      // console.log(this.liveData.planDateToStart)
      this.showPlanDateToStart = `${year}-${month}-${day}`
      if(this.startTime==this.liveData.planDateToStart){
        this.startHour=new Date().getHours();
        this.startMinute = new Date().getMinutes();
      }else{
        this.startHour = 0;
        this.startMinute = 0;
      }
      this.show = false
    },
    showPopup2 () {
      this.show2 = true
      this.isLoadingShow2 = true
      setTimeout(() => {
        this.isLoadingShow2 = false
      }, 500)
    },
    confirmPicker2 (val) {
      this.liveData.planTimeToStart = val;
      this.show2 = false
    },
    change(picker){
      if(this.startHour==parseInt(picker.getValues()[0])){
        this.startMinute = new Date().getMinutes();
      }else{
        this.startMinute = 0;
      }
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    changeUrl(urls) {
      this.url = urls;
    },
    textInput() {
      this.shownumber = this.liveData.briefIntroduction.length;
    },
    createLiveRoom() {
      let that = this
      if(!that.liveData.roomName) {
        return MessageBox.alert("请输入直播名称", "提示");
      }
      if(!that.liveData.anchorName) {
        return MessageBox.alert("请输入直播人", "提示");
      }
      if(!that.liveData.anchorCompany) {
        return MessageBox.alert("请输入直播楼盘", "提示");
      }
      if(!that.liveData.planDateToStart) {
        return MessageBox.alert("请选择预计开始日期", "提示");
      }
      if(!that.liveData.planTimeToStart) {
        return MessageBox.alert("请选择预计开始时间", "提示");
      }
      
      Indicator.open();
      if(that.rid){
        if(that.isPlanDateToStart){
          that.liveData.planDateToStart = that.showPlanDateToStart;
        }
        that.liveData.roomId = that.rid;
        that.liveData.projectId = that.pid
        // console.log(that.showPlanDateToStart)
        config.editLiveRoom(that.liveData).then(response => {
          Indicator.close();
          if(response.code == 0) {            
            MessageBox.confirm("",{
                 title: "提示",
                 message:"是否需要通知预约粉丝",
                }
              ).then((action)=>{
                if (action == "confirm") {
                  //确认 则消息模板推送通知预约粉丝
                  config.sendMsgByUpdate(that.rid).then(res => {
                    if(res.code == 0) {
                        let url = `${location.protocol}//${location.host}/h5/live/liveroominfo?rid=${response.data.roomId}&t9id=${that.receiveSpreadInfo.t9id}&t9psn=${that.receiveSpreadInfo.t9psn}&pid=${that.pid}`;
                        util.openYqRsMakeLink(url);
                    }
                  })
                }
             
            }).catch(err => {
              if (err == "cancel") {
                //取消的回调
                let url = `${location.protocol}//${location.host}/h5/live/liveroominfo?rid=${response.data.roomId}&t9id=${that.receiveSpreadInfo.t9id}&t9psn=${that.receiveSpreadInfo.t9psn}&pid=${that.pid}`;
                util.openYqRsMakeLink(url);
              }
            });
          } else {
            return MessageBox("提示", response.msg);
          }
        });
      }else{
        that.$nextTick(()=>{
          that.liveData.planDateToStart = util.getTime(that.liveData.planDateToStart)
        })
        // console.log('this.liveData.planDateToStart====>', this.liveData.planDateToStart)
        that.liveData.projectId = that.pid;
        config.createLiveRoom( that.liveData).then(response => {
          Indicator.close();
          if(response.code == 0) {            
            MessageBox.alert("创建成功", "提示").then(()=>{
              let url = `${location.protocol}//${location.host}/h5/live/liveroominfo?rid=${response.data.roomId}&t9id=${that.receiveSpreadInfo.id}&t9psn=${that.receiveSpreadInfo.psn}&pid=${that.pid}`;
              util.openYqRsMakeLink(url);
            });
          } else {
            return MessageBox("提示", response.msg);
          }
        });
        console.log('===>',that.liveData)
      }
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      if(this.pid) {      
        if (this.pageInfo.Extinfo) {
          if (this.pageInfo.Extinfo.content_pagetags) {
            let pagetagsObj = {
              // channel: null,
              // banner: null,
              // 热点新闻: null,
              // 精选项目: null
            };
            pagetagsObj.channel = {
              pagetags: this.pageInfo.Extinfo.content_channel_tags,
              tagname: this.pageInfo.Extinfo.content_channel_tags_name
            };
            // this.couponChannelId = pagetagsObj.channel.pagetags;
            this.couponChannelId = this.pageInfo.Pid;
            this.pageInfo.Extinfo.content_pagetags.forEach(item => {
              pagetagsObj[item.section] = item;
            });

            comreq
              .listPageInfoWithChannel2(
                pagetagsObj.channel.pagetags,
                pagetagsObj["精选项目"].pagetags
              )
              .then(data => {
                if (data && data.list) {
                  data.list.forEach(item => {
                    if (item.extinfo && parseInt(item.pid) == this.pid) {
                      item.extinfo = JSON.parse(item.extinfo);
                      if (item.extinfo.advantage) {
                        item.extinfo.advantage = item.extinfo.advantage.split(
                          ","
                        );
                      }
                      this.curProject = item
                      this.liveData.roomName = item.extinfo.buildingName
                      this.liveData.anchorCompany = item.extinfo.buildingName
                      this.liveData.briefIntroduction = item.extinfo.advantage ? item.extinfo.advantage.join(",") : ''
                      if(this.liveData.briefIntroduction) {
                        this.shownumber = this.liveData.briefIntroduction.length
                      }
                      this.liveData.bannerImgUrl = item.banner_imgurl
                      if (
                        item.extinfo.actConfig &&
                        item.extinfo.actConfig.open_getcoupon1 == 1 &&
                        item.extinfo.actConfig.getcoupon1_banner_img
                      ) {
                        //配置了优惠券
                        this.liveData.hasCoupon = true;
                        this.showCoupon = true;
                      }
                    }
                  });
                }
                console.log("项目详情>>>", this.curProject);
              });
          }
        }
      }
      if(this.rid) {
        config.myLiveRoomByRoomId(this.rid).then(response => {
          if(response.code == 0) {
            this.liveData = {
              roomName: response.data.roomName,
              anchorName: response.data.anchorName,
              anchorCompany: response.data.anchorCompany,
              briefIntroduction: response.data.briefIntroduction,
              planDateToStart: response.data.planDateToStart,
              planTimeToStart: response.data.planTimeToStart,
              bannerImgUrl: response.data.bannerImgUrl,
              hasCoupon: response.data.hasCoupon,
              status: response.data.status,
            }
            if(response.data.planDateToStart) {
              this.showPlanDateToStart = response.data.planDateToStart
            }
            if(response.data.briefIntroduction) {
              this.shownumber = response.data.briefIntroduction.length
            }
          } else {
            return MessageBox("提示", response.msg);
          }      
        })
      }
      comreq.getUserIntegralInfo().then(userInfo => {
        console.log('userInfo>>>>',userInfo)
        if(userInfo.isSale == true) {
          this.userInfo = userInfo.userInfo.user
          this.liveData.anchorName = this.userInfo.name
          console.log(this.liveData.anchorName)
        } else {
          MessageBox.alert("非注册销售不能创建直播", "提示").then(()=>{
            window.history.go(-1);
          });
        }
      });
    });
  },
  mounted() {
     console.log('this.startDate=====>',new Date(new Date().getFullYear() - 10, 0, 1))
  }
};
</script>
<style lang="css" scoped>
.wrapper {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  background-color: #f5f5f5;
  overflow: auto;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;  
}
.title-layer {
  line-height: .8rem;
  color: #666666;
  padding-left: .2rem;
  font-size: .3rem;
}
.content-layer {
  background-color: #ffffff;
}
.field-layer {
  display: flex;
  line-height: .88rem;
}
.field-layer > label {
  width: 2.4rem;
  text-align: left;
  padding-left: .2rem;
  font-size: .32rem;
  font-weight: 600;
}
.field-layer > span {
  flex: 1;
  text-align: right;
  padding-right: .2rem;
}
.label-layer {
  text-align: left;
  padding-left: .2rem;
  font-size: .32rem;
  font-weight: 600; 
  line-height: .88rem; 
}
.field-layer .info-input {
  flex: 1;
}
.upimg-layer {
  padding-left: .2rem;
}
.upimg-layer .upimg {
  width: 100%;
  height: 2rem;
  background-color: #999;
  background: url('http://rs.static.quanc.com.cn/yq-rs-wx/register/icon_upimg.png') no-repeat;
  background-size: 3rem 2rem;
  position: relative;
}

.upimg-layer .upimg > img {
  width: 3rem;
  height: 2rem;
}
.note-layer {
  line-height: .88rem;
  padding-left: .2rem;
  color: #666666;
  font-size: .26rem;
}
.content-layer > textarea {
  width: 92%;
  margin: 0 auto;
  display: block;
  line-height: .5rem;
}
.number-layer {
  line-height: .5rem;
  text-align: right;
  padding-right: .2rem;
  font-size: .26rem;
}
.switch-layer {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  padding: .2rem .1rem;
}
.switch-layer .left {
  flex: 1;
}
.switch-layer .left .t1 {
  font-size: .32rem;
  font-weight: 600; 
  line-height: .5rem; 
}
.switch-layer .left .t2 {
  font-size: .24rem;
  line-height: .5rem; 
  color: #666666;
}
.tabbar {
  width: 100%;
  height: 1.2rem;
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  border-top: 1px solid #c6c6c6;  
}
.btn-layer {
  width: 80%;
  margin: 0.5rem auto;
  height: .88rem;
  background-color: #F75302;
  color: #ffffff;
  font-size: .28rem;
  text-align: center;
  line-height: .88rem;
  border-radius: .4rem;
}
</style>